import { RouteName } from '../../../core/enums/route-name.enum'

/** True for the My Plan route, with or without a query string or fragment. */
export const isMyPlanUrl = (url: string): boolean =>
  url.split(/[?#]/)[0] === '/' + RouteName.MyPlan
